export const reviews: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Electrical Engineering Educator | London',
    'My students finally understand electrical fundamentals, circuit analysis, electrical machines, and power systems. Now I enter the classroom fully prepared.',
  ],
  [
    'JW',
    'Jennifer W.',
    'Technical Instructor | Dublin',
    'I know exactly how to explain circuit theorems, transformer operation, motor characteristics, and power generation. This resource does the heavy lifting for me.',
  ],
  [
    'NC',
    'Nora C.',
    'Electrical Engineering Teacher | Amsterdam',
    'The lesson planning saves me countless hours. The integrated projects are organized step-by-step. I never improvise anymore.',
  ],
];

export const moreResults: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Educator',
    "Circuit analysis and electrical machines completely changed how my students understand electrical engineering. It's the clearest resource I've found.",
  ],
  [
    'JW',
    'Jennifer W.',
    'Instructor',
    'The 150 activities alone are worth the price. I never improvise anymore. Everything is prepared and ready.',
  ],
  [
    'MS',
    'Martin S.',
    'Instructor',
    'The 100 case studies were eye-opening. My students analyze real electrical challenges and understand how technical reasoning contributes to power system reliability.',
  ],
];
